import { observer } from 'mobx-react';
import React from 'react';
import { promocodeStore } from '~/view/screens/MarketingScreen/screens/PromocodesScreen/store/promocodeStore';
import { InputWithTextInside } from '~/view/components/Controls/Inputs';
import Text from '~/view/components/Text/Text';
import TabPicker from '~/view/components/Controls/Pickers/TabPicker/TabPicker';
import Input from '~/view/components/Controls/InputComponent/Input';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';

const conditionOptions: IPickerOption[] = [
  { value: 0, label: 'days' },
  { value: 1, label: 'weeks' },
];

const ReoccurringUsageLimitsFields = observer(() => {
  const isActiveUsageLimits = promocodeStore.promocode.reoccurring_usage_limited;

  const onChangeReoccurringUsageIntervalType = (value: 0 | 1) => {
    promocodeStore.changePromocode({ reoccurring_usage_interval_type: value ?? 0 });
  };

  const onChangeUsageNumberPerInterval = (value: string | undefined) => {
    promocodeStore.changePromocode({ usage_number_per_interval: value ? Number(value) : 0 });
  };

  const onChangeReoccurringUsageInterval = (value: string | undefined) => {
    promocodeStore.changePromocode({ usage_interval: value ? Number(value) : 0 });
  };

  if (!isActiveUsageLimits) return null;
  return (
    <>
      <div className="d-flex flex-row mt-4 gap-10">
        <InputWithTextInside
          type="number"
          value={promocodeStore.promocode.usage_number_per_interval ?? 0}
          onChangeValue={onChangeUsageNumberPerInterval}
          textProps={{ text: 'promocode_usage_number_per_interval' }}
          maxLength={5}
          contentClassName="promocode-conditions__input_large"
        />
      </div>
      <div className="mt-4 gap-20">
        <Text type="block-header" text="promocode_usage_interval" />
        <div className="d-flex flex-row mt-2 gap-10">
          <TabPicker
            value={promocodeStore.promocode.reoccurring_usage_interval_type ?? 0}
            options={conditionOptions}
            onChange={onChangeReoccurringUsageIntervalType}
          />
          <Input
            type="number"
            className="promocode_small_field"
            maxLength={5}
            value={promocodeStore.promocode.usage_interval ?? 0}
            onChangeValue={onChangeReoccurringUsageInterval}
            placeholder={'0'}
          />
        </div>
      </div>
    </>
  );
});

export default ReoccurringUsageLimitsFields;
